import React, { useEffect, useState } from "react";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import { toast } from "react-toastify";

import api, { openApi } from "../../services/api";
import toastError from "../../errors/toastError";

/**
 * Login com Google — vinculo da conta no cadastro do usuario (UserModal).
 *
 * Nao aparece nada se o login Google estiver desligado (status publico !== enabled)
 * ou se o backend nao tiver a rota. O proprio usuario vincula (vai ao Google e volta
 * em /tickets?googleLink=...) e desvincula; o admin da mesma empresa so' ve e desvincula.
 * O backend nunca manda o googleId, so' "vinculado" e o e-mail da conta Google.
 */
const GoogleLinkSection = ({ userId, isSelf }) => {
  const [enabled, setEnabled] = useState(false);
  const [info, setInfo] = useState(null);
  const [busy, setBusy] = useState(false);

  const statusPath = isSelf ? "/auth/google/link" : `/auth/google/link/${userId}`;

  useEffect(() => {
    let alive = true;
    if (!userId) return undefined;
    (async () => {
      try {
        const { data: st } = await openApi.get("/auth/google/status");
        if (!alive || st?.enabled !== true) return;
        const { data } = await api.get(statusPath);
        if (!alive) return;
        setInfo(data || null);
        setEnabled(true);
      } catch (_) {
        if (alive) setEnabled(false);
      }
    })();
    return () => {
      alive = false;
    };
  }, [userId, statusPath]);

  if (!enabled || !info) return null;

  const handleLink = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/auth/google/link");
      if (data?.url && /^https:\/\/accounts\.google\.com\//.test(data.url)) {
        window.location.href = data.url;
        return;
      }
      toast.error("Não foi possível iniciar o vínculo com o Google.");
    } catch (err) {
      toastError(err);
    }
    setBusy(false);
  };

  const handleUnlink = async () => {
    setBusy(true);
    try {
      await api.delete(statusPath);
      setInfo({ ...info, linked: false, googleEmail: null });
      toast.success("Conta Google desvinculada.");
    } catch (err) {
      toastError(err);
    }
    setBusy(false);
  };

  return (
    <Grid container spacing={1} alignItems="center" style={{ marginTop: 4 }}>
      <Grid item xs={12} md={8}>
        <Typography variant="body2" color="textSecondary">
          {info.linked
            ? `Conta Google vinculada${info.googleEmail ? `: ${info.googleEmail}` : ""}`
            : isSelf
              ? "Nenhuma conta Google vinculada. Vincule para usar \"Entrar com Google\"."
              : "Nenhuma conta Google vinculada."}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        {info.linked ? (
          <Button
            variant="outlined"
            size="small"
            fullWidth
            disabled={busy}
            onClick={handleUnlink}
            style={{ textTransform: "none" }}
          >
            Desvincular Google
          </Button>
        ) : isSelf ? (
          <Button
            variant="outlined"
            color="primary"
            size="small"
            fullWidth
            disabled={busy}
            onClick={handleLink}
            style={{ textTransform: "none" }}
          >
            Vincular conta Google
          </Button>
        ) : null}
      </Grid>
    </Grid>
  );
};

export default GoogleLinkSection;
